var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_page",attrs:{"id":"app"}},[_c('HeaderComponent'),_c('CalculateComponent'),_c('FooterComponents')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }